import React from 'react';
import OctoberLogo from 'images/october-logo.svg';

const CATEGORIES = [
  { id: "sweet-wine", title: `Sweet Wines`, href: '/sweet-wines' },
  { id: "beer",
    title: (
      <div>
        <div>Beers of the Month Curated by</div>
        <img className="image-links__logo" src={OctoberLogo} alt="October"></img>
        <div className="image-links__subtitle">oct.co</div>
      </div>
    ),
    href: '/beers-of-the-month' },
  { id: "whiskey", title: `‘Me Time’ Whiskeys`, href: '/me-time-whiskeys' },
  { id: "sake", title: `Ichi, Ni, San… Sake Sake BOMB!`, href: '/sake' },
  { id: "rose", title: `Rosé all day`, href: '/rose' }
];

const List = () => {
  return (
    <div className="row center-md image-links">
      { CATEGORIES.map((category, idx) => {
        return (
          <div key={ category.id } className={ `image-links__container` }>
            <Item idx={ idx} { ...category } />
          </div>
        )
      }) }
    </div>
  )
}

const Item = (props) => {
  return (
    <a href={ props.href } >
      <div className={`image-links__image image-links__image--${ props.id }`}>
        { props.title }
      </div>
    </a>
  );
}

export default List;



// WEBPACK FOOTER //
// ./shared/components/home/landingPage/categories.js